<template>
  <a-dropdown
    v-if="comDatas.isfounder === 1"
    placement="bottomRight"
  >
    <a
      href="javascript:;"
      class="manage-org-btn"
    >
      {{ $t('message["413"]') }} <i class="icon iconfont iconicon-test69" />
    </a>
    <a-menu slot="overlay">
      <template>
        <a-menu-item @click="editOrgName">
          {{ $t('message["1394"]') }}
        </a-menu-item>
        <edit-org-dialog
          ref="editOrgName"
          :org-item-data="comDatas"
        />
        <a-menu-item @click="transferOrg">
          {{ $t('message["1644"]') }}
        </a-menu-item>
        <first-tran-dia
          ref="firstTranDialog"
          :com-datas="comDatas"
          @tiggerTransfer="tiggerTransfer"
        />
        <second-tran-dia
          ref="secondTranDialog"
          :com-datas="comDatas"
        />

        <a-menu-item
          v-if="!$isDingDing"
          @click="dismissOrg"
        >
          {{ $t('message["520"]') }}
        </a-menu-item>
        <dismiss-dialog
          ref="dismissDialog"
          :com-datas="comDatas"
        />
        <org-tip-dialog
          ref="tipDialog"
          :manage-type="manageType"
          :com-datas="comDatas"
          @triggerMethod="triggerMethod"
        />
      </template>
    </a-menu>
  </a-dropdown>
</template>
<script>
import OrgTipDialog from './OrgTipDialog'
import DismissDialog from './DismissOrgDialog'
import FirstTranDia from './FirstTranDia'
import SecondTranDia from './SecondTranDia'
import EditOrgDialog from './EditOrgDialog'
import { mapState, mapActions } from 'vuex'
export default {
  components: {
    OrgTipDialog,
    DismissDialog,
    FirstTranDia,
    SecondTranDia,
    EditOrgDialog
  },
  props: {
    comDatas: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      manageType: ''
    }
  },
  computed: {
    ...mapState('organization/org', ['baseinfoData']),
    cid () {
      return this.$route.query.cid
    }
  },

  methods: {
    ...mapActions('organization/org', ['fetchOrgSelectDatas', 'ajaxDismissOrg']),
    dismissOrg () {
      this.manageType = 'dismiss'
      this.$refs.tipDialog.changeLimitDialog(true)
    },
    transferOrg () {
      this.manageType = 'transfer'
      this.$refs.tipDialog.changeLimitDialog(true)
    },
    async triggerMethod (val) {
      if (val === 'transfer') {
        if (this.$isDingDing) {
          this.tiggerTransfer()
        } else {
          this.$refs.firstTranDialog.changeVisible(true)
        }
      } else if (val === 'dismiss') {
        // 钉钉没有解散组织的功能了
        if (this.$isDingDing) {
          const chain = await this.ajaxDismissOrg()
          chain
            .params({ cid: this.comDatas.cid })
            .fetch()
        } else {
          this.$refs.dismissDialog.changeVisible(true)
        }
      }
    },
    async tiggerTransfer () {
      const chain = await this.fetchOrgSelectDatas()
      chain.params({ cid: this.comDatas.cid })
        .onSuccess(() => {
          this.$refs.secondTranDialog.changeVisible2(true)
        })
        .config({ warn: false, tip: false })
        .fetch()
    },
    jump3 (val) {
      this.$router.push({ path: '/organization/cloud',
        query: {
          cid: this.comDatas.cid,
          comname: this.comDatas.comname,
          isCloud: this.comDatas.private_cloud_status,
          type: val
        } })
    },
    editOrgName () {
      this.$refs.editOrgName.changeVisible(true)
    }
  }
}
</script>
<style lang="scss" scoped>
.manage-org-btn {
  margin-left: 32px;
  i {
    color: #ccc;
  }
}
</style>
